import { useGtm } from '@gtm-support/vue-gtm'
import sha256 from 'crypto-js/sha256'
import encHex from 'crypto-js/enc-hex'

/**
 * gtmTrackEvent function
 * 
 * @param {*} options 
 */
function gtmTrackEvent(options, hash = true) {
    const gtm = useGtm();
    if (gtm && gtm.enabled()) {
        let dataOptions = options
        if (hash) {
            dataOptions = encryptDataBeforePush(dataOptions)
        }
        gtm.trackEvent(dataOptions)
    }
}

/**
 * encryptDataBeforePush function
 * 
 * @param {*} options 
 * @returns 
 */
function encryptDataBeforePush(options = {}) {
    let encryptedOptions = { ...options }
    const keysAllowedToEncrypt = [
        'email',
        'phone',
        'customerEmail',
        'customerPhoneNumber',
    ]

    // Encrypt specific keys
    for (const key in encryptedOptions) {
        if (keysAllowedToEncrypt.includes(key)) {
            encryptedOptions[key] = encryptData(encryptedOptions[key])
        }
    }
    return encryptedOptions
}

/**
 * encryptData function
 * 
 * @param {*} data 
 * @returns 
 */
function encryptData(data) {
    try {
        const encrypted = sha256(data)
        return encrypted.toString(encHex)
    } catch (e) {
        if (process.env.NODE_ENV !== 'production') console.error('[gtm.encryptData] Error encrypting data:', e)
    }
}

export { gtmTrackEvent, encryptData, encryptDataBeforePush }